// Mapper only: snake_case PowerTranz API payloads -> camelCase for components. No requests here.

export const mapPowerTranzAccount = (data) => ({
  // Backend-confirmed availability for new payments (pilot, flags, merchant status, billing,
  // currency). The UI never works this out from the other fields.
  isPayable: data?.is_payable === true,
  // The API doesn't send is_payable yet; until it does the UI says nothing about availability
  // rather than claim new payments are off for a healthy account.
  isPayableKnown: typeof data?.is_payable === "boolean",
  // False when the guide isn't in the PowerTranz pilot. Absent means the API didn't say; connecting
  // is then left to the API to accept or refuse.
  isEligible: data?.is_eligible !== false,
  isConnected: !!data?.is_connected,
  connectionStatus: data?.connection_status || null,
  billingStanding: data?.billing_standing || null,
  isTokenizationEnabled: !!data?.tokenization_enabled,
  pageSet: data?.page_set || "",
  pageName: data?.page_name || "",
  verifiedAt: data?.verified_at || null,
  // The guide's processing fee for PowerTranz charges, in percent (0 = none).
  cardFeeRate: Number(data?.card_fee_rate) || 0,
  lastVerificationError: data?.last_verification_error || null,
  // The last 4 characters of the saved PowerTranz ID (never the whole ID); null when none is saved.
  idLast4: data?.powertranz_id_last4 || null,
  // Who guests pay through, decided by the API (PowerTranz when payable, else Stripe, else PayPal).
  checkoutPaymentProvider: data?.checkout_payment_provider || null
})

export const mapSavedCard = (card) =>
  card
    ? {
        id: card.id ?? null,
        brand: card.brand || "",
        lastFour: card.last_four || ""
      }
    : null

// POST /powertranz/create_payment
export const mapPowerTranzPaymentSession = (data) => ({
  attemptRef: data?.attempt_ref,
  incomeId: data?.income_id,
  redirectData: data?.redirect_data,
  expiresAt: data?.expires_at,
  amount: data?.amount,
  currency: data?.currency,
  isSavingCard: !!data?.saves_card
})

// GET /powertranz/status
export const mapPowerTranzPaymentStatus = (data) => ({
  state: data?.state,
  failureReason: data?.failure_reason || null,
  attemptRef: data?.attempt_ref || null,
  expiresAt: data?.expires_at || null,
  income: data?.income || null,
  booking: data?.booking || null,
  savedCard: mapSavedCard(data?.saved_card)
})

// GET /guide/platform_fees
export const mapPlatformFeeInvoice = (invoice) => ({
  id: invoice.id,
  periodStart: invoice.period_start,
  periodEnd: invoice.period_end,
  status: invoice.status,
  totalCents: invoice.total_cents,
  currency: invoice.currency,
  paidAt: invoice.paid_at || null
})
